import { render, staticRenderFns } from "./InfoField.vue?vue&type=template&id=94055158&"
import script from "./InfoField.vue?vue&type=script&lang=js&"
export * from "./InfoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports